// frontend/src/services/lessonService.js
// A teacher's own lessons (call map sections 9–11, docs/openapi.yaml): upload and analyse, My lessons,
// the analysis page, share for research, delete and the CSV download. Owner only. Never confidence
// scores or probabilities (YES-204): every statistic on the analysis page is computed in the page.
import api from './api';

const enc = encodeURIComponent;

// LessonRow[]: newest first; teacherShare only when ready
export const listMyLessons = async () => (await api.get('/api/lessons')).data.lessons;

// The request stays open until the analysis is done or failed. → { lessonId, status: ready | failed }.
// A 400 with problems is a file check the page missed; a 413 is a file over 5 MB.
export const uploadLesson = async ({ file, name, subject, gradeLevel, researchUse }) => {
    const form = new FormData();
    form.append('file', file);
    if (name?.trim()) form.append('name', name.trim());
    if (subject?.trim()) form.append('subject', subject.trim());
    if (gradeLevel) form.append('gradeLevel', gradeLevel);
    if (typeof researchUse === 'boolean') form.append('researchUse', String(researchUse));
    return (await api.post('/api/lessons', form)).data;
};

// A Word transcript as the upload will read it (YES-311) → { layout, columns, rows }; nothing is stored.
// The page runs its file check on these rows, as on a CSV.
export const readTranscript = async (file) => {
    const form = new FormData();
    form.append('file', file);
    return (await api.post('/api/lessons/read', form)).data;
};

// Try again after a failed analysis: reruns the stored rows, nothing is uploaded again
export const retryAnalysis = async (lessonId) => (await api.post(`/api/lessons/${enc(lessonId)}/analysis`)).data;

// LessonReport: the lesson and, once ready, its coded utterances (number, role, text, ut, rc)
export const getLesson = async (lessonId) => (await api.get(`/api/lessons/${enc(lessonId)}`)).data;

// One way: a shared lesson can't be unshared or deleted (decision 2026-10-20)
export const shareLesson = async (lessonId) => (await api.post(`/api/lessons/${enc(lessonId)}/share`)).data;

export const deleteLesson = async (lessonId) => (await api.delete(`/api/lessons/${enc(lessonId)}`)).data;

// Columns number, speaker, utterance, utteranceType, reasoningComponent; no confidence columns
export const exportLessonCsv = async (lessonId) => {
    const response = await api.get(`/api/lessons/${enc(lessonId)}/export`, { responseType: 'blob' });
    const name = (response.headers?.['content-disposition'] || '').match(/filename="?([^";]+)"?/)?.[1];
    return { blob: response.data, fileName: name };
};
